module.exports = __webpack_public_path__ + "static/media/banner-promotion.2444c149.png";